export default ($) => {
    $('.navbar .additional-menu .menu__item.lang .dropdown-item, .mobile-panel .dropdown.lang .dropdown-item').each((index, element) => {
        $( element ).on( "click", function(event) {
            var $parent = $(this).closest('.dropdown.lang');
            $parent.find('.current-lang').removeClass('current-lang');
            $(this).addClass('current-lang');
            var $lang = 'EN';
            switch ($(this).data('lang')) {
                case 'fr_CA':
                  $lang = "FR";
                  break;
                case 'es_US':
                  $lang = "ES";
                  break;
                default:
                  $lang = "EN";
            }
            $parent.find('.dropdown-toggle').html('<i class="fa-solid fa-earth-americas fa-spin"></i>' + $lang + '<i class="fa-solid fa-chevron-down"></i>');
        });
    });
}